import { render } from "./search-pagination.vue?vue&type=template&id=1d33e062&scoped=true"
import script from "./search-pagination.vue?vue&type=script&lang=js"
export * from "./search-pagination.vue?vue&type=script&lang=js"

import "./search-pagination.vue?vue&type=style&index=0&id=1d33e062&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d33e062"]])

export default __exports__